import { getZodiacName } from "../../../shared/utils";
import { convertDateToUserTimezoneWithTime } from "../../../utils/dateFromat";

export default function DashaRow({ data, timezone = "UTC", onClick, className}) {
    if (!data) return null;

    return (
        <tr
            className={`border-b ${className}`}
            onClick={onClick}
        >
            <td className="py-2 px-3">{getZodiacName(data.sign)}</td>
            <td className="py-2 ps-8">{data.sign}</td>
            <td className="py-2 px-3">{convertDateToUserTimezoneWithTime(data.startDate, timezone)}</td>
            <td className="py-2 px-3">{convertDateToUserTimezoneWithTime(data.endDate, timezone)}</td>
        </tr>
    );
}
